import React from 'react';

// Skeleton loader for product cards
export const ProductCardSkeleton = () => (
    <div className="bg-white rounded-2xl overflow-hidden shadow-lg animate-pulse">
        <div className="aspect-square bg-gradient-to-br from-amber-100 to-orange-100" />
        <div className="p-5 space-y-3">
            <div className="h-4 bg-amber-100 rounded w-3/4" />
            <div className="h-4 bg-amber-100 rounded w-1/2" />
            <div className="h-6 bg-amber-100 rounded w-1/3" />
            <div className="flex justify-between pt-4 border-t border-amber-50">
                <div className="h-4 bg-amber-100 rounded w-20" />
                <div className="h-4 bg-amber-100 rounded w-12" />
            </div>
        </div>
    </div>
);

// Skeleton loader for text
export const TextSkeleton = ({ width = 'w-full', height = 'h-4' }) => (
    <div className={`${width} ${height} bg-gradient-to-r from-amber-100 via-amber-50 to-amber-100 rounded animate-pulse`} />
);

// Skeleton loader for image
export const ImageSkeleton = ({ className = 'w-full h-48' }) => (
    <div className={`${className} bg-gradient-to-br from-amber-100 to-orange-100 rounded-xl animate-pulse`} />
);

// Skeleton loader for stats card
export const StatCardSkeleton = () => (
    <div className="bg-white p-6 rounded-2xl shadow-lg animate-pulse">
        <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-amber-100 rounded-xl" />
            <div className="flex-1 space-y-2">
                <div className="h-8 bg-amber-100 rounded w-20" />
                <div className="h-4 bg-amber-100 rounded w-24" />
            </div>
        </div>
    </div>
);

// Skeleton loader for table row
export const TableRowSkeleton = ({ columns = 5 }) => (
    <tr className="animate-pulse">
        {[...Array(columns)].map((_, i) => (
            <td key={i} className="px-4 py-3">
                <div className="h-4 bg-amber-100 rounded w-full" />
            </td>
        ))}
    </tr>
);

// Generic skeleton wrapper
export const Skeleton = ({ className = '', variant = 'text' }) => {
    const baseClasses = 'animate-pulse bg-gradient-to-r from-amber-100 via-amber-50 to-amber-100';
    
    const variants = {
        text: 'h-4 rounded',
        title: 'h-8 rounded',
        avatar: 'rounded-full',
        card: 'rounded-2xl',
        button: 'h-10 rounded-xl',
    };
    
    return <div className={`${baseClasses} ${variants[variant]} ${className}`} />;
};

export default Skeleton;
